import { createSelector } from 'reselect';

const stateSelector = state => state.freeminutes;

export const addingSelector = createSelector(stateSelector, state => state.adding);
export const fetchingSelector = createSelector(stateSelector, state => state.fetching);
export const listSelector = createSelector(stateSelector, state => state.list);
export const acceptedCitiesSelector = createSelector(stateSelector, state => state.acceptedCities);
